import * as React from "react";
import {
    Text,
    UnorderedList
} from "@mbank-design/design-system/components";

interface UnorderedListViewProps {
    items: string[];
    spacing?: number;
}

export const UnorderedListView = (props: UnorderedListViewProps): JSX.Element | null => {
    if (props.items.length === 0) {
        return null;
    }

    return (
        <>
            {props.items.map((value: string, index: number) => (
            <UnorderedList key={index} spacing={props.spacing}>
                <UnorderedList.Item>
                    <Text>
                        {value}
                    </Text>
                </UnorderedList.Item>
            </UnorderedList>))}
        </>
    );
}
